import React, {createContext, useContext, useState, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {LoginRepository} from "../../repository/AdminDashboard/LoginRepository";
import toast, {Toaster} from "react-hot-toast";
import {LoginUseContext} from "./LoginContext";
// Create the context
const StateContext = createContext();
// Define the OtpContext component
const OtpContext = ({children}) => {
    // Helper function to generate initial OTP state
    const generateInitialOtpState = () => Array(5).fill("");

    // State variables
    const [otp, setOtp] = useState(generateInitialOtpState);
    const [loading, setloading] = useState(false);

    // Get phoneNumber from LoginContext
    const {phoneNumber} = LoginUseContext();

    // Ref for input elements
    const inputRefs = useRef([]);

    // Ref for input elements
    const navigate = useNavigate();

    // Function to check OTP
    const checkotp = async (otpValues) => {
        setloading(true);

        const setsmsId = localStorage.getItem("smsId");
        const code = otpValues.join("");
        const data = await LoginRepository.checkotp(setsmsId, code);
        setloading(false);

        // Handle the response data
        if (data.code == 1) {
            localStorage.setItem("token", data.token);
            localStorage.setItem("refreshToken", data.refreshToken);
            localStorage.setItem("role", data.role);
            navigate("/admin/home");
            toast.success(data.massage, {
                className: "text-12 text-dark-blue-200",
            });


        } else if (data.code === 0) {
            setTimeout(() => {
                toast.error(data.massage, {
                    className: "text-12 text-dark-blue-200",
                });
            }, 1);
        }
    };

    // Function to handle OTP input change
    function handleOtpChange(event, index) {
        const value = event.target.value;
        const newOtp = [...otp];
        newOtp[index] = value || "";
        setOtp(newOtp);

        // Check if OTP is complete and submit
        const isOtpComplete = newOtp.every((digit) => digit);
        if (isOtpComplete && index === otp.length - 1) {
            newOtp[4] = value;
            setOtp(newOtp);
            handleSubmit(newOtp);
        } else if (value) {
            inputRefs.current[index + 1].focus();
        } else if (index > 0) {
            inputRefs.current[index - 1].focus();
        }
    }

    // Function to handle OTP input key down
    function handleOtpKeyDown(event, index) {
        if (event.key === "Backspace" && !otp[index]) {
            inputRefs.current[index - 1].focus();
        }
    }

// Function to handle pasting OTP
    function handleOtpPaste(event) {
        event.preventDefault();
        const pastedData = event.clipboardData
            .getData("text/plain")
            .slice(0, otp.length - inputRefs.current.indexOf(document.activeElement));
        const newOtp = [...otp];
        for (let i = 0; i < pastedData.length; i++) {
            newOtp[inputRefs.current.indexOf(document.activeElement) + i] =
                pastedData[i];
        }
        setOtp(newOtp);
    }

    // Function to handle OTP form submission
    const handleSubmit = async (event) => {
        await checkotp(event);
    };

    // Provide the context value to the children components
    return (
        <StateContext.Provider
            value={{
                otp,
                handleOtpChange,
                handleOtpPaste,
                handleOtpKeyDown,
                inputRefs,
                handleSubmit,
                phoneNumber,
                loading,
            }}>
            {children}
        </StateContext.Provider>
    );
};

// Function to use the OtpContext in components
function OtpUseContext() {
    return React.useContext(StateContext);
}

// Export the OtpUseContext and OtpContext
export {OtpUseContext};
export default OtpContext;
